import React from 'react';
import { useDiagnostics } from 'context/DiagnosticsContext';

function bar(ms, max) {
  const pct = max > 0 ? Math.min(100, Math.round((ms / max) * 100)) : 0;
  const color = ms > 3000 ? '#f87171' : ms > 1000 ? '#fb923c' : '#34d399';
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
      <div style={{ flex: 1, height: 4, background: '#1e293b', borderRadius: 2 }}>
        <div style={{ width: `${pct}%`, height: '100%', background: color, borderRadius: 2, transition: 'width 0.3s' }} />
      </div>
      <span style={{ fontSize: 10, color: '#94a3b8', minWidth: 42, textAlign: 'right' }}>{ms} ms</span>
    </div>
  );
}

function DashboardPerfPanel({ onClose }) {
  const ctx = useDiagnostics();
  const timings = ctx?.timings ?? {};

  const rows = Object.entries(timings)
    .map(([id, t]) => ({ id, ...t }))
    .sort((a, b) => b.totalMs - a.totalMs);

  const maxMs = rows.reduce((m, r) => Math.max(m, r.totalMs), 0);

  return (
    <div className="perf-panel-backdrop" onClick={onClose}>
      <div className="perf-panel" onClick={e => e.stopPropagation()}>
        <div className="perf-panel-header">
          <span className="perf-panel-title">⚡ Widget Performance Bottlenecks</span>
          <button className="perf-panel-close" onClick={onClose}>✕</button>
        </div>

        {rows.length === 0 ? (
          <p style={{ color: '#64748b', fontSize: 12, padding: '12px 0' }}>
            No timing data yet — widgets will report here as they load.
          </p>
        ) : (
          <table className="perf-table">
            <thead>
              <tr>
                <th>Widget</th>
                <th>Total</th>
                <th>API</th>
                <th>DB</th>
                <th>Cache</th>
              </tr>
            </thead>
            <tbody>
              {rows.map(r => (
                <tr key={r.id} className={r.error ? 'perf-row--error' : ''}>
                  <td className="perf-td-name">{r.id}</td>
                  <td>{bar(r.totalMs, maxMs)}</td>
                  <td className="perf-td-num">{r.serverMs != null ? `${r.serverMs} ms` : '—'}</td>
                  <td className="perf-td-num">{r.dbMs != null ? `${r.dbMs} ms` : '—'}</td>
                  <td>
                    <span className={`perf-badge ${
                      r.fromCache        ? 'perf-badge--client' :
                      r.cacheStatus === 'HIT'   ? 'perf-badge--server' :
                      r.cacheStatus === 'STALE' ? 'perf-badge--stale'  : 'perf-badge--miss'
                    }`}>
                      {r.fromCache ? 'Client' : r.cacheStatus || 'MISS'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        <p style={{ fontSize: 10, color: '#475569', marginTop: 12 }}>
          Red = &gt;3s · Orange = &gt;1s · Green = fast · Rows sorted slowest first
        </p>
      </div>
    </div>
  );
}

export default DashboardPerfPanel;
